import { InjectionToken } from '@angular/core';
import { IEnvironment } from '@app/interfaces';

export const ENVIROMENT = new InjectionToken<IEnvironment>('ENVIROMENT');
